var __jsx = React.createElement;
import React from 'react';
import useIsMobile from '@hooks/useIsMobile';
import { useCMS } from "@hooks/useCMS";
var SellCarSteps = function SellCarSteps(_ref) {
  var data = _ref.data;
  var isMobile = useIsMobile();
  var _useCMS = useCMS(),
    imageUrl = _useCMS.imageUrl;
  return /*#__PURE__*/React.createElement("div", {
    id: "sell-car-steps-section",
    className: "pb-8 md:py-20 px-4 "
  }, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-steps-container",
    className: "max-w-[1200px] mx-auto"
  }, /*#__PURE__*/React.createElement("h2", {
    id: "sell-car-steps-title",
    className: "text-primary-new text-[20px] font-bold leading-[32px] md:text-[32px] text-center  mb-8 md:mb-12"
  }, data.title), /*#__PURE__*/React.createElement("div", {
    id: "sell-car-steps-grid",
    className: "flex flex-col md:grid md:grid-cols-2 gap-6 md:gap-10"
  }, data.payloads.map(function (step, index) {
    var stepImage = isMobile ? step.main_image.image_mobile : step.main_image.image_desktop;
    return /*#__PURE__*/React.createElement("div", {
      id: "sell-car-step-".concat(index),
      key: step.id,
      className: "w-full"
    }, /*#__PURE__*/React.createElement("img", {
      id: "sell-car-step-image-".concat(index),
      loading: "lazy",
      src: imageUrl(stepImage),
      alt: step.title,
      className: "w-full h-auto object-contain"
    }));
  }))));
};
export default SellCarSteps;